import React, { useState } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ChangePasswordModal = ({ show, onClose }) => {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!show) return null;

  const set = (f) => (e) => setForm((p) => ({ ...p, [f]: e.target.value }));

  const handleClose = () => {
    setForm({ current: "", next: "", confirm: "" });
    setError("");
    setSuccess("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.current.trim()) { setError("Current password is required."); return; }
    if (form.next.length < 8) { setError("New password must be at least 8 characters."); return; }
    if (form.next !== form.confirm) { setError("Passwords do not match."); return; }
    setError("");
    setSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${BASE_URL}/api/v1/auth/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          currentPassword: form.current,
          newPassword: form.next,
          confirmPassword: form.confirm,
        }),
      });
      const data = await res.json();
      if (data.status) {
        setSuccess(data.message || "Password updated successfully.");
        setForm({ current: "", next: "", confirm: "" });
        setTimeout(() => { setSuccess(""); handleClose(); }, 1500);
      } else {
        setError(data.message || "Failed to update password.");
      }
    } catch {
      setError("Network error. Please try again.");
    }
    setSubmitting(false);
  };

  const inputStyle = {
    width: "100%", padding: "9px 12px", fontSize: 13,
    border: "1px solid #e2e8f0", borderRadius: 8, outline: "none",
    marginTop: 6,
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(15,23,42,0.4)", display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={handleClose}
    >
      <div
        style={{ background: "#fff", borderRadius: 14, padding: "28px 28px 20px", maxWidth: 400, width: "90%", boxShadow: "0 8px 32px rgba(15,23,42,0.18)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h6 style={{ fontWeight: 700, fontSize: 16, color: "#0f172a", margin: "0 0 18px" }}>Change Password</h6>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#475569" }}>Current Password</label>
            <input type="password" style={inputStyle} value={form.current} onChange={set("current")} required />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#475569" }}>New Password</label>
            <input type="password" style={inputStyle} value={form.next} onChange={set("next")} required />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#475569" }}>Confirm New Password</label>
            <input type="password" style={inputStyle} value={form.confirm} onChange={set("confirm")} required />
          </div>
          {error && <p style={{ fontSize: 12, color: "#dc2626", margin: "0 0 12px" }}>{error}</p>}
          {success && <p style={{ fontSize: 12, color: "#059669", margin: "0 0 12px" }}>{success}</p>}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
            <button type="button" className="btn btn-light" style={{ fontSize: 13, borderRadius: 8 }} onClick={handleClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" style={{ fontSize: 13, borderRadius: 8 }} disabled={submitting}>
              {submitting ? "Updating..." : "Update Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
